class Representative {
  constructor (obj) {
    this.name = obj.Name
    this.firstName = obj.First_name
    this.lastName = obj.Last_name
    this.email = obj.Email
    this.phone = obj.Phone
    this.photoURL = obj.Photo_URL
    this.website = obj.Source_URL
    this.party = obj.Party_name
  }
}

module.exports = Representative



// WEBPACK FOOTER //
// ./src/models/Representative.js